import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class Key extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene
     */
    constructor(scene, keyId, w, h)
    {
        super(scene);

        this.keyWidth = w;
        this.keyHeight = h;

        this.keyValue = keyId;
        if (this.keyValue.indexOf("shift") != -1) this.keyValue = "shift";
        if (this.keyValue == "shift" || this.keyValue == "enter" || this.keyValue == "delete")
        {
            this.keyWidth = w * 2;
        }
        else if (this.keyValue == "space")
        {
            this.keyWidth = w * 5;
        }

        this.setInteractive(
            {
                hitArea: new Phaser.Geom.Rectangle(0, 0, this.keyWidth, this.keyHeight),
                hitAreaCallback: Phaser.Geom.Rectangle.Contains,
                useHandCursor: false
            }
        );

        this.keyId = keyId + "_key";
        this.keyShape = this.scene.add.graphics();
        this.add(this.keyShape);

        const localeKeys = ['shift', 'delete', 'space', 'enter'];
        const keyStr = localeKeys.indexOf(this.keyValue) !== -1 ? ABCyaPhaser.Localization.instance.getLocalizedString('keyboard.' + localeKeys[localeKeys.indexOf(this.keyValue)]) : this.keyValue;
        const fontSize = 26;
        this.keyText = ABCyaPhaser.Text.addText(this.keyWidth / 2, this.keyHeight / 2, fontSize, 0x333333, FontKeys._asapregular, keyStr, this, true);
    }

    showKeyPress(isDown)
    {
        this.isDown = isDown;
        this.keyShape.clear();
        let newColor = (this.isDown == true) ? this.downColor : this.upColor;
        this.keyShape.fillStyle(newColor);
        this.keyShape.fillRoundedRect(0, 0, this.keyWidth, this.keyHeight, 6);
    }

    upperCase()
    {
        if (this.keyValue == "shift" || this.keyValue == "enter" || this.keyValue == "delete") return;

        this.keyValue = this.keyValue.toUpperCase();
        let keyStr = this.keyValue;
        this.keyText.text = keyStr;
    }

    lowerCase()
    {
        if (this.keyValue == "shift" || this.keyValue == "enter" || this.keyValue == "delete") return;

        this.keyValue = this.keyValue.toLowerCase();
        let keyStr = this.keyValue;
        this.keyText.text = keyStr;
    }

    setKeyColors(color1, color2)
    {
        this.upColor = color1;
        this.downColor = color2;
        this.showKeyPress(false);
    }
}